<template>
  <div class="driver-topbar-wrap">
    <v-row>
      <v-col cols="6">
        <div class="driver-nav" @click="viewDrivers()">
          <span class="cursor-pointer">Drivers</span>
          <span class="px-1">></span>
        </div>
        <div class="active-driver">
          {{activeDriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}
        </div>
      </v-col>
      <v-col cols="6" class="d-flex justify-end align-center">
        <div class="d-flex">
          <v-menu offset-y offset-overflow max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="box-container zoom-in ml-1 mr-4"
              :disabled="!checkPermission(['data_export'])"
            >
              <v-icon small class="mr-2">las la-cloud-download-alt</v-icon>
              <span>Export report</span>
            </v-btn>
          </template>
          <v-list three-line>
            <v-list-item  @click="downloadReport('withfilter')">
              <v-list-item-avatar>
                <i class="las la-filter"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Currently filtered</v-list-item-title>
                <v-list-item-subtitle>
                  Export report of all data
                  that are currently shown in the
                  table on the page.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="downloadReport()">
              <v-list-item-avatar>
                <i class="las la-user-friends"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>All data</v-list-item-title>
                <v-list-item-subtitle>
                  Export the list of all data
                  that are present.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
          <driverJumpto
          ></driverJumpto>
          <v-btn
            class="box-container zoom-in ml-2"
            @click="toggleFilter()"
          >
            <i class="las la-filter mr-2"></i>
            <span>Filter</span>
          </v-btn>
          <v-btn
            class="box-container zoom-in ml-2"
            v-if="isFilterApplied"
            @click="resetFilter()"
          >
            <i class="las la-sync-alt"></i>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import DriverJumpto from '../common-comp/driver-jumpto';

export default {
  name: 'DriverTopbar',

  components: {
    DriverJumpto
  },

  props: {
    activeDriver: {
      required: true,
      type: String
    },
    isFilterApplied: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      dashboardFilters: state => state.updateDriversFilters
    })
  },
  beforeMount () {
    console.log(this.$route.query);
  },
  methods: {
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    resetFilter () {
      this.$emit('resetReportFilters');
    },
    downloadReport (type) {
      const queryParams = {};
      if (type === 'withfilter') {
        if (this.dashboardFilters.user__profile__high_potential_emp) {
          queryParams.user__profile__high_potential_emp = true;
        }
        if (this.dashboardFilters.initiated_date_end) {
          queryParams.initiated_date_start = this.dashboardFilters.initiated_date_start;
          queryParams.initiated_date_end = this.dashboardFilters.initiated_date_end;
        }
        if (this.dashboardFilters && this.dashboardFilters.filters) {
          this.$lodash.each(this.dashboardFilters.filters, (v, k) => {
            if (v.length > 0 && k !== 'session__stage__title') {
              queryParams[`user__profile__${k}__in`] = v.join();
            } else {
              queryParams.stage__title__in = v.join();
            }
          });
        }
      }
      axios.get(`${process.env.VUE_APP_API_URL}reports/download_driver_analytics_excel_report?report_type=driver_analysis_dashboard&sheets=driver_touchpoints_covered,stats_dashboard,drivers_analysis_heatmap,drivers_responses&fields=engagement_stats,response_stats,milestone_wise_analysis,engagement_heatmap,demographic_wise_score&driver=${this.$route.query.driver}`, {
        params: queryParams
      }).then((response) => {
        // console.log('response', response);
        this.withFilterData = false;
        if (response && response.data && response.data.success) {
          if (response.data.report_url) {
            this.downloadingFlag = false;
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.report_url);
            }, 100);
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.reportDialog = false;
        }
        this.downloadingFlag = false;
      }).catch((err) => {
        if (err.response.status === 429) {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
    },
    toggleFilter () {
      this.$emit('toggleFilter');
    },
    viewDrivers () {
      this.$router.push({
        path: '/drivers'
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.driver-topbar-wrap {
  background: #050550;
  background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
  padding: 0 12px;
  border-bottom: 2px solid rgba(0,0,0,0.1);
  .active-driver {
    color: var(--bg);
    // font-size: var(--content-size);
    // font-size: var(--stats-size-2);
    font-size: 32px;
  }
  .driver-nav {
    color: var(--bg);
    // font-size: var(--content-sub-size);
    font-size: var(--heading-size);
    font-size: var(--content-size);
  }
}
</style>
